import React, {Component} from 'react';
import axios from 'axios';
import {FaCloud, FaSearch} from "react-icons/fa";
import {
    Card, CardBody, Table, InputGroup, Input, InputGroupAddon, Button, Alert,
} from 'reactstrap';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import PaginateComponent from "../../../components/PaginateComponent";
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
import ListButtonVpsUsComponent from "../../../components/Customer/vps_us/ListButtonVpsUsComponent";
import ListVpsUsCancelComponent from "../../../components/Customer/vps_us/ListVpsUsCancelComponent";

class ListVpsUsAllPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listService: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            from: '',
            to: '',
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            qtt: 30,
            q: '',
            checkAll: false,
            os: 0,
            checkedStart: -1,
            btn_all: 'Chọn hành động',
            rq_table: {
                per_page: 10,
                page: 0,
                s: '',
                ms: '',
                order_by: 'id',
                order: 'desc',
                type: '',
                typeList: 'search'
            },
            vpsToast: [],
            vpsUpdate: [],
            textVpsToast: '',
            typeToast: 1,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListVps();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    updateStatusVps = () => {
        if ( typeof (this.state.vpsUpdate.length) !== 'undefined' ) {
            if (this.state.vpsUpdate.length) {
                let dataAuth = {
                    username: process.env.REACT_APP_CLIENT_ID,
                    password: process.env.REACT_APP_CLIENT_PASSWD,
                    token: process.env.REACT_APP_KEY,
                };
                let data = "?listVpsId=" + this.state.vpsUpdate;

                axios.get( process.env.REACT_APP_API_URL + '/api/vps/updateStatusVps' + data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization' : this.props.token,
                            'dataAgency' : JSON.stringify(dataAuth)
                        }
                    }
                )
                    .then( (ref) => {
                        console.log(ref.data);
                        if ( ref.data.error === 0 ) {
                            let listService = [];
                            let vpsUpdate = [];
                            ref.data.content.forEach( (vpsStatus) => {
                                this.state.listService.forEach( (vps) => {
                                    if ( vpsStatus.id === vps.id ) {
                                        vps.status_vps = vpsStatus.status_vps;
                                    }
                                    if ( vps.status_vps === 'progressing' || vps.status_vps === 'rebuild' || vps.status_vps === 'reset_password'
                                        || vps.status_vps === 'change_ip' || vps.status_vps === 'waiting'
                                    ) {
                                        vpsUpdate.push( vps.id );
                                    }
                                    listService.push( vps );
                                })
                            })
                            this.setState({
                                listService: listService,
                                vpsUpdate: vpsUpdate,
                                vpsToast: ref.data.content
                            })
                        }
                        // console.log(this.state.perPage);
                    })
            }
        }
    }

    getListVps = () => {
        this.setState({
            isLoading: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // let data = "?qtt=" + this.state.qtt + "&q=" + this.state.q + "&type=using";

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : this.props.token,
                'dataAgency' : JSON.stringify(dataAuth)
            },
            params: this.state.rq_table
        }

        axios.get( process.env.REACT_APP_API_URL + '/api/vps-us/getListVpsUs', config)
            .then( (ref) => {
                if ( ref.data.error === 0 ) {
                    let vpsUpdate = [];
                    if (ref.data.content.data.length) {
                        ref.data.content.data.forEach( (vps) => {
                            if ( vps.status_vps === 'progressing' || vps.status_vps === 'rebuild' || vps.status_vps === 'reset_password'
                                || vps.status_vps === 'change_ip' || vps.status_vps === 'waiting'
                            ) {
                                vpsUpdate.push( vps.id );
                            }
                        })
                    }
                    this.setState({
                        listService: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        from: ref.data.content.from,
                        to: ref.data.content.to,
                        currentPage: ref.data.content.current_page,
                        loadPage: false,
                        isLoading: false,
                        rq_table: ref.data.content.filters,
                        vpsUpdate: vpsUpdate
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu VPS thất bại',
                })
            })
    }


    changeQtt = async (event) => {
        let value = event.target.value;
        await this.setState({
            rq_table: {
                ...this.state.rq_table,
                per_page: value
            }
        })
        await this.getListVps();
    }

    search = (e) => {
        let text  = e.target.value;
        let r = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/; //192.168.1.1
        let r2 = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}:\d{1,5}\b/;
        let ip = '';
        let ips = '';
        if ( text.match(r2) ) {
            while (text.match(r2) != null) {
                ip = text.match(r2)[0];
                ips += ip + ',';
                text = text.replace(ip, '');
            }
        }
        if ( text.match(r) ) {
            while (text.match(r) != null) {
                ip = text.match(r)[0];
                ips += ip + ',';
                text = text.replace(ip, '');
            }
        }
        if (typeof(ips) !== 'undefined' && ips !== '') {
            ips = ips.slice(0, -1);
            ips = ips.replace('undefined', '');
            this.setState(
                {
                    rq_table: {
                        ...this.state.rq_table,
                        [e.target.name]: ips,
                        typeList: 'searchMulti'
                    }
                }
            )
        }
        else {
            this.setState(
                {
                    rq_table: {
                        ...this.state.rq_table,
                        [e.target.name]: e.target.value,
                        typeList: 'search'
                    }
                }
            )
        }
    }

    submitSearch = (e) => {
        if(e.key === 'Enter') {
            this.setState(
                {
                    currentPage: 0,
                    rq_table: {
                        ...this.state.rq_table,
                        page: 0
                    }
                },
                () => this.getListVps()
            )
        }
    }

    btnSearch = () => {
        this.setState(
            {
                currentPage: 0,
                rq_table: {
                    ...this.state.rq_table,
                    page: 0
                }
            },
            () => this.getListVps()
        )
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState(
            {
                currentPage: page,
                rq_table: {
                    ...this.state.rq_table,
                    page: page
                }
            },
            () => this.getListVps()
        )
    }

    btnChangeType = (type) => {
        this.setState(
            {
                rq_table: {
                    ...this.state.rq_table,
                    type: type,
                    page: 0
                }
            },
            () => this.getListVps()
        )
    }

    screentListService = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={20}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listService.length ) {
                return (
                    this.state.listService.map( (service, key) => {
                        return (
                            <ListVpsUsCancelComponent
                                key={key}
                                service={service}
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="20">
                            Không có VPS trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={ `Tất cả dịch vụ VPS US`} page={"VPS US"} icon={<FaCloud className="breadcrumb-icon"/>} />
                            <div className="list-button">
                                <ListButtonVpsUsComponent active="all" />
                            </div>
                            <hr/>
                            <Card>
                                <CardBody className="table-responsive">
                                    <div className="row">
                                        <div className="col-md-5">
                                        </div>
                                        <div className="col-md-7">
                                            <InputGroup className="input-group-sm m-1">
                                                <Input
                                                    id="search"
                                                    name="s"
                                                    placeholder="Tìm kiếm VPS theo IP"
                                                    onChange={ this.search }
                                                    onKeyPress={ this.submitSearch }
                                                    value={ this.state.rq_table.s }
                                                />
                                                <InputGroupAddon addonType="prepend">
                                                    <Button onClick={ () => this.btnSearch() }> <FaSearch /> </Button>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        </div>
                                        {
                                            this.state.listService.length ? (
                                                <div className="col-12 my-1">
                                                    Hiển thị từ { this.state.from } đến { this.state.to } / Tổng: { this.state.totalPage }
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        <div className="col-md-12">
                                            {
                                                this.checkNotification()
                                            }
                                        </div>
                                        <div className="col col-md-12">
                                            <Table className="table table-sm table-bordered table-hover rounded text-center table-service">
                                                <thead className="primary">
                                                    <tr>
                                                        <th>IP/State</th>
                                                        <th>Mật khẩu</th>
                                                        <th>Cấu hình</th>
                                                        <th>Ngày tạo</th>
                                                        <th>Ngày kết thúc</th>
                                                        <th>Tổng thời gian thuê</th>
                                                        <th>Chu kỳ thanh toán</th>
                                                        <th>Chi phí</th>
                                                        <th>Trạng thái</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                { this.screentListService() }
                                                </tbody>
                                                <tfoot className="card-footer clearfix">
                                                    <tr>
                                                        <td colSpan="20" className="link-right">
                                                            { this.paginate() }
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerVpsAll' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListVpsUsAllPage);